"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sheet = void 0;
const Contract = require("@tableau/api-external-contract-js");
const api_shared_js_1 = require("@tableau/api-shared-js");
const Parameter_1 = require("./Parameter");
class Sheet extends api_shared_js_1.EventListenerManager {
    constructor(_sheetImpl) {
        super();
        this._sheetImpl = _sheetImpl;
    }
    get name() {
        return this._sheetImpl.name;
    }
    get sheetType() {
        return this._sheetImpl.sheetType;
    }
    get size() {
        if (this.isValidSize(this._sheetImpl.size)) {
            return this._sheetImpl.size;
        }
        throw new api_shared_js_1.TableauError(Contract.EmbeddingErrorCodes.ImplementationError, 'Size not implemented');
    }
    isValidSize(size) {
        const testSize = size;
        if (testSize.width !== undefined && testSize.height !== undefined) {
            return true;
        }
        return false;
    }
    findParameterAsync(parameterName) {
        return this._sheetImpl.findParameterAsync(parameterName).then((parameterImpl) => {
            if (parameterImpl) {
                return new Promise((resolve) => resolve(new Parameter_1.Parameter(parameterImpl, this)));
            }
            else {
                return new Promise((resolve) => resolve(undefined));
            }
        });
    }
    getParametersAsync() {
        return this._sheetImpl.getParametersAsync().then((parametersImpl) => {
            return parametersImpl.map((parameterImpl) => {
                return new Parameter_1.Parameter(parameterImpl, this);
            });
        });
    }
}
exports.Sheet = Sheet;
//# sourceMappingURL=Sheet.js.map